import { useMatomo } from '@datapunt/matomo-tracker-react';
import { Box, List, ListItem, ListItemText, ListSubheader } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { MProfile } from '../../redux/scholarship.models';
import { selectProfilesChild, selectProfilesParent } from '../../redux/scholarship.selectors';
import { ApplicationFormContainer } from '../ApplicationsForm/applications-form.styles';

const ProfilesList = () => {
  const navigate = useNavigate();
  const profilesParent = useSelector(selectProfilesParent as (state: unknown) => MProfile[]);
  const profilesChild = useSelector(selectProfilesChild as (state: unknown) => MProfile[]);
  const { trackPageView } = useMatomo();

  // Track page view
  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <div>
      <Box pt={3} pb={3} pl={1}>
        <ApplicationFormContainer>
          <Typography variant="h6" gutterBottom>
            Family Profiles
          </Typography>
          <Box width="50%" mb={2}>
            <List subheader={<ListSubheader component={'div'}>Child Profiles</ListSubheader>} style={{ backgroundColor: '#f0f0f0' }}>
              {profilesChild.map((row) => {
                return (
                  <ListItem
                    button
                    onClick={() => navigate(`/applications/profiles/child/${row.id}`, { state: { fromProfilesList: true } })}
                    key={'child_' + row.id}
                  >
                    <ListItemText primary={`${row.firstName} ${row.lastName}`} />
                  </ListItem>
                );
              })}
            </List>
          </Box>
          <Box width="50%">
            <List subheader={<ListSubheader component={'div'}>Parent Profile</ListSubheader>} style={{ backgroundColor: '#f0f0f0' }}>
              {profilesParent.map((row) => {
                return (
                  <ListItem
                    button
                    onClick={() => navigate(`/applications/profiles/parent/${row.id}`, { state: { fromProfilesList: true } })}
                    key={'parent_' + row.id}
                  >
                    <ListItemText primary={`${row.firstName} ${row.lastName}`} />
                  </ListItem>
                );
              })}
            </List>
          </Box>
        </ApplicationFormContainer>
      </Box>
    </div>
  );
};

export default ProfilesList;
